import { notes } from "@phoenixreisen/mithrils/src/notification";
import { getPhxId } from "../../../shared/functions/booking";
import { email, phone } from "@phoenixreisen/form";
import { logError } from "../../../shared/functions/misc";
import { saveContactWays } from "../shared/functions";
import User from "@phoenixreisen/user";
import Config from "../../../config";
import m from "mithril";
const submit = async (state, e) => {
    e?.preventDefault();
    const { email, phone } = state.form;
    email.validate(email.value());
    phone.validate(phone.value());
    if (!email.complaint && !phone.complaint) {
        state.submitting = true;
        try {
            const jwt = User.jwt;
            const useremail = email.value();
            const userphone = phone.value();
            const username = getPhxId(User);
            await saveContactWays(jwt, username, useremail, userphone);
            location.href = Config.urls.OVERVIEW;
        }
        catch (e) {
            notes.add({
                status: "error",
                text: `Deine Email konnte nicht gespeichert werden.
                Probiere es noch einmal und wende dich zur Not an die IT.`,
            });
            logError(e);
        }
        finally {
            state.submitting = false;
            m.redraw();
        }
    }
    else {
        notes.add({
            status: "error",
            text: `Bitte prüfe deine Eingaben.
            Email muss angegeben werden.`,
        });
    }
};
export const View = {
    oninit({ state }) {
        const required = true;
        state.form = {
            email: email(required),
            phone: phone(!required),
        };
        state.submitting = false;
    },
    view({ state }) {
        const { form, submitting } = state;
        const { email, phone } = form;
        const { urls } = Config;
        try {
            return (m("form", { class: "form email-form", onsubmit: (e) => submit(state, e) },
                m("p", { class: "pa2 mv2 gray6 c-gray1" }, "Bitte speichere noch kurz mindestens deine Email. Sie ist bislang nicht in der Datenbank hinterlegt."),
                m("label", { class: "textfield" },
                    m("input", { type: "text", name: "email", maxLength: "100", autocomplete: "email", value: email.value(), oninput: (e) => email.validate(e.target.value), placeholder: "z.B. f.marcus@phoenixreisen.com" }),
                    m("span", { class: `textfield__label ${email.complaint ? "alert--warning" : ""}` }, "E-Mail")),
                m("label", { class: "textfield" },
                    m("input", { type: "text", name: "phone", maxLength: "100", autocomplete: "phone", value: phone.value(), oninput: (e) => phone.validate(e.target.value), placeholder: "z.B. 0163 30 60 539" }),
                    m("span", { class: `textfield__label ${phone.complaint ? "alert--warning" : ""}` }, "Handynummer (dienstl.)")),
                m("div", { class: "tr" },
                    m("button", { type: "submit", disabled: submitting },
                        submitting && m("i", { class: "fas fa-spinner fa-spin mr2" }),
                        "Speichern"))));
        }
        catch (e) {
            logError(e);
            location.href = urls.FE_ERROR;
        }
    },
};
export default View;
